import { render, staticRenderFns } from "./ImportFileButton.vue?vue&type=template&id=7027f051&scoped=true&"
import script from "./ImportFileButton.vue?vue&type=script&lang=js&"
export * from "./ImportFileButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7027f051",
  null
  
)

export default component.exports